/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { colors } from '_styles';
import { connect } from 'react-redux';
import styled, { keyframes } from 'styled-components';
import { _ } from '_locales';
import { Button } from '../../Education/components';
import { formatPhoneNumber } from '../heplers';
import { Select } from '../../../components';

const ContactInformation = ({
  windowsWidth,
  mainColor,
  currentPage,
  setCurrentPage,
  contactInfo,
  setContactInfo,
  addressDetails,
  submitFormFields
}) => {
  const [emailOnBlur, setEmailOnBlur] = useState();
  const [firstNameOnBlur, setFirstNameOnBlur] = useState();
  const [lastNameOnBlur, setLastNameOnBlur] = useState();
  const [phoneOnBlur, setPhoneOnBlur] = useState();
  const { main_color } = mainColor;

  const {
    firstName = '', lastName = '', phone = '', email = ''
  } = contactInfo;
  const { projectId, districtId } = addressDetails;
  const isValidEmail = (email) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  };

  const isMandatory = (field) => {
    if ((field === 'name' && submitFormFields?.name === 'mandatory')) return true;
    if ((field === 'email' && submitFormFields?.email === 'mandatory')) return true;
    if ((field === 'phone' && submitFormFields?.phone === 'mandatory')) return true;
    return false;
  };

  const isSkip = (
    (submitFormFields?.name === 'optional' || submitFormFields?.name === 'hidden')
    && (submitFormFields?.email === 'optional' || submitFormFields?.email === 'hidden')
    && (submitFormFields?.phone === 'optional' || submitFormFields?.phone === 'hidden')
  ) && !(firstName || lastName || phone || email);

  const isNextDisabled = (
    (submitFormFields?.email !== 'hidden'
      && ((submitFormFields?.email === 'mandatory' && !email)
        || (email && !isValidEmail(email))))
    || (submitFormFields?.name === 'mandatory' && submitFormFields?.name !== 'hidden' && !firstName)
    || (submitFormFields?.name === 'mandatory' && submitFormFields?.name !== 'hidden' && !lastName)
    || (submitFormFields?.phone !== 'hidden'
      && ((submitFormFields?.phone === 'mandatory' && !phone)
        || (phone && phone.length < 18)))
  ) && !isSkip;

  const handlePhoneNumberChange = (event) => {
    if (event.target.value.length > 18) return;
    const inputPhoneNumber = event.target.value;
    const formatted = formatPhoneNumber(inputPhoneNumber);
    setContactInfo({ ...contactInfo, phone: formatted });
  };

  return (
    <Container>
      <Wrapper>
        <TextHeader>
          {_('bulkPickup.please_provide_information')}
        </TextHeader>
        <form onSubmit={(e) => {
          e.preventDefault();
          setCurrentPage(currentPage + 1);
        }}
        >
          <View style={{ display: 'flex', gap: windowsWidth > 650 ? 20 : 0, flexDirection: windowsWidth > 650 ? 'row' : 'column' }}>
            {submitFormFields?.name !== 'hidden' && (
              <View style={{ flex: 1 }}>
                <Input
                  onKeyDown={(e) => e.stopPropagation()}
                  id="firstName"
                  type="text"
                  name="firstName"
                  placeholder={`${_('bulkPickup.first_name')}${isMandatory('name') ? '*' : ''}`}
                  value={firstName}
                  onChange={(e) => setContactInfo({ ...contactInfo, firstName: e.target.value })}
                  windowsWidth={windowsWidth}
                  onBlur={() => setFirstNameOnBlur(true)}
                />
                {firstName.length < 1 && firstNameOnBlur
                  && (
                    <Error>
                      {_('bulkPickup.first_name')}
                      {' '}
                      {_('bulkPickup.must_be_valid')}
                      !
                    </Error>
                  )}
              </View>
            )}
            {submitFormFields?.name !== 'hidden' && (
              <View style={{ flex: 1 }}>
                <Input
                  onKeyDown={(e) => e.stopPropagation()}
                  id="lastName"
                  type="text"
                  name="lastName"
                  placeholder={`${_('bulkPickup.last_name')}${isMandatory('name') ? '*' : ''}`}
                  value={lastName}
                  onChange={(e) => setContactInfo({ ...contactInfo, lastName: e.target.value })}
                  windowsWidth={windowsWidth}
                  onBlur={() => setLastNameOnBlur(true)}
                />
                {lastName.length < 1 && lastNameOnBlur && isMandatory('name')
                  && (
                    <Error>
                      {_('bulkPickup.last_name')}
                      {' '}
                      {_('bulkPickup.must_be_valid')}
                      !
                    </Error>
                  )}
              </View>
            )}
          </View>
          <View style={{ display: 'flex', gap: windowsWidth > 650 ? 20 : 0, flexDirection: windowsWidth > 650 ? 'row' : 'column' }}>

            {submitFormFields?.phone !== 'hidden' && (
              <View style={{ flex: 1 }}>
                <Input
                  onKeyDown={(e) => e.stopPropagation()}
                  id="phone"
                  name="phone"
                  placeholder={`${_('bulkPickup.telephone')}${isMandatory('phone') ? '*' : ''}`}
                  value={phone}
                  windowsWidth={windowsWidth}
                  onChange={handlePhoneNumberChange}
                  onBlur={() => setPhoneOnBlur(true)}
                />
                {phone.length < 18 && phoneOnBlur
                  && (
                    <Error>
                      {_('bulkPickup.telephone')}
                      {' '}
                      {_('bulkPickup.must_be_valid')}
                      !
                    </Error>
                  )}
              </View>
            )}

            {submitFormFields?.email !== 'hidden' && (
              <View style={{ flex: 1 }}>
                <Input
                  onKeyDown={(e) => e.stopPropagation()}
                  id="email"
                  type="email"
                  name="email"
                  placeholder={`${_('bulkPickup.email')}${isMandatory('email') ? '*' : ''}`}
                  value={email}
                  windowsWidth={windowsWidth}
                  onBlur={(e) => setEmailOnBlur(true)}
                  onChange={(e) => setContactInfo({ ...contactInfo, email: e.target.value })}
                />
                {!isValidEmail(email) && emailOnBlur
                  && (
                    <Error>
                      {_('bulkPickup.email')}
                      {' '}
                      {_('bulkPickup.must_be_valid')}
                      !
                    </Error>
                  )}
              </View>
            )}
          </View>

          <View style={{
            display: 'flex', gap: 20, marginTop: 20, justifyContent: 'flex-end'
          }}
          >
            <Button
              backgroundColor="fff"
              color={main_color || colors.RC_ACTION}
              aria-label={'Back'}
              fontSize="16px"
              padding="12px 24px"
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              {_('bulkPickup.back')}
            </Button>
            <Button
              mainColor={main_color || false}
              aria-label={'Next'}
              fontSize="16px"
              padding="12px 24px"
              type="submit"
              disabled={isNextDisabled}
            >
              {isSkip ? _('bulkPickup.skip') : _('bulkPickup.next')}
            </Button>
          </View>
        </form>

      </Wrapper>
    </Container>
  );
};

export default connect((state) => ({
  mainColor: state.config.templateColour ? JSON.parse(state.config.templateColour) : {},
}), null)(ContactInformation);

const Input = styled.input`
  width: 100%;
  height: 50px;
  display: block;
  padding: 0 10px;
  height: 50px;
  border-radius: 3px;
  margin-top: 15px;
  box-sizing: border-box;
  color: rgb(64, 64, 64) !important;
  font-size: 14px;
  border: 1px solid #0086C2;
  font-family: Roboto, sans-serif !important;
`;

const TextHeader = styled.h3`
  letter-spacing: 1px;
  cursor: pointer;
  font-size: 18px !important;
  color: rgb(64, 64, 64) !important;
  font-weight: 600 !important;
  font-family: Roboto, sans-serif !important;
`;

const Container = styled.div`
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 18px 0px;
  margin-top: 15px;
  margin-bottom: 35px;

  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0; 
}
`;

const OpacityAnimation = keyframes`
  from { opacity: 0;}
  to { opacity:1;}
`;

const View = styled.div`
  animation: ${OpacityAnimation} 0.5s;
`;

const Wrapper = styled.div`
  margin: 15px auto;
  max-width: 600px;
`;

const Error = styled.p`
  color: rgb(178, 1, 7);
  margin: 5px 0 0 0;
  font-size: 13px;
  font-family: Roboto, sans-serif !important;
`;
const Text = styled.h3`
  font-size: 18px;
  text-transform: capitalize;
`;
